<template>
  <div>
    <template v-if="game">
      <h3>Проверка ответов ({{game.name}})</h3>
      <el-row>
        <el-col :span="6">
          <el-select v-model="selectedTeam" placeholder="Выберите команду">
            <el-option
              v-for="team in teams"
              :key="team.id"
              :label="team.name"
              :value="team.id"
              >
            </el-option>
          </el-select>
        </el-col>
        <el-col :offset="2" :span="6">Раунд:</el-col>
        <el-col :span="6"><el-input-number v-model="round" :min="0" :max="20" /></el-col>
      </el-row>
      <hr/> 
      <el-row class="answers_check">
        <el-col :span="11">Правильный</el-col>
        <el-col :span="11">Ответ команды</el-col>
        <el-col :span="2">Засчитать</el-col>
      </el-row>
      <el-row
        v-for="(teamAnswer, index) in correctAnswers"
        :key="index"
        :class="{correct: aproved[index], incorrect: !aproved[index]}">
        <el-col :span="11"><pre>{{correctAnswers[index]}}</pre></el-col>
        <el-col :span="11"><pre>{{teamAnswers[index] || "."}}</pre></el-col>
        <el-col :span="2"><el-checkbox v-model="aproved[index]" /></el-col>
      </el-row>
      <el-button @click="saveTeamPoints">Проверено, го дальше</el-button>
    </template>
    <template v-else>
       Нет такой игры или неверный ID игры
    </template>
  </div>
</template>

<script>
export default {
  name: 'AdminCheckAnswers',
  data() {
    return {
      selectedTeam: null,
      round: 0,
      aproved: [],
      savedApprovals: {}
    }
  },
  props: ['gameid'],
  computed: {
    game() {
      return this.$store.getters.game(this.gameid);
    },
    teamAnswers() {
      return this.$store.state.gameAnswers
        ?.find(ans => ans.team_id == this.selectedTeam && ans.round == this.round)?.answers
        || [];
    },
    currentGameRound() {
      return this.$store.state.currentGame.round; //should usually be next one, currently paused
    },
    correctAnswers() {
      return this.game?.rounds[this.round]?.answers;
    },
    teams() {
      const existingTeamsIds = this.game ? new Set(Object.keys(this.game.teams)): [];
      return this.$store.state.teams.filter(t => existingTeamsIds.has(t.id));
    }
  },
  methods: {
    saveTeamPoints() {
      const totalScoresForRound = this.aproved.reduce((acc, cur)=>acc+cur,0);
      this.$store.dispatch('saveRoundScores', {
        game_id: this.gameid,
        team_id: this.selectedTeam,
        round: this.round,
        score: totalScoresForRound
      })
        .then(() => {
          this.savedApprovals[this.selectedTeam] = [...this.aproved];
          const currentTeamIndexInList = this.teams.findIndex(t => t.id == this.selectedTeam);
          if(currentTeamIndexInList < this.teams.length - 1) {
            //move next
            this.selectedTeam =  this.teams[currentTeamIndexInList+1].id;
          } else {
            this.$message({type: 'info', message: 'Вы проверили все команды, это последняя'});
            // TODO save this.savedApprovals
          }
        })
        .catch(err => this.$message({type: 'error', message: err.message}));
    },
  },
  mounted() {
    this.$store.dispatch('initGameAnswers', this.gameid);
  },
  watch: {
    teams:{
      handler(newTeams) {
        this.selectedTeam = newTeams?.[0]?.id;
      },
      immediate: true
    },
    teamAnswers(newSelectedTeamId) {
      if(this.savedApprovals[newSelectedTeamId] && this.savedApprovals[newSelectedTeamId].length > 0) {
        this.aproved = [...this.savedApprovals[newSelectedTeamId]];
      } else {
        const aproved = [];
        this.teamAnswers.forEach((teamAnswer, answerIdx) => {
          const answerVariants = this.correctAnswers[answerIdx]?.split('\n').map(a => a.trim());
          aproved[answerIdx] = answerVariants.includes(teamAnswer.trim());
        });
        this.aproved = [...aproved];
      }
    },
    currentGameRound: {
      handler(newCurGameRoundVal) {
        this.round = newCurGameRoundVal - 1 || 0;
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
 .answers_check {
   border: 1px solid #eee;
   padding: 5px;
 }
 .correct {
   background: #cfc;
   padding: 5px;
 }
 .incorrect {
   background: #fcc;
   padding: 5px;
 }
</style>